<template>
  <div>
    <ts-page-title
      :title="$t('exchangeRate.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('exchangeRate.pageTitle'),
                    active: true
                }
            ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="d-flex justify-content-between">
          <Button type="info" ghost @click="addNew()">
            {{ $t('addNew') }}
          </Button>
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
      </Table>
      <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
        <ts-i-pagination
          v-model="pagination" @navigate="fetchData"
        ></ts-i-pagination>
      </div>
      <!-- form-action -->
      <Modal
        v-model="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer-hide="true"
        :z-index="1020"
        width="500px"
        :title="$t('exchangeRate.pageTitle')"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </Modal>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'exchangeRateIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('exchangeRate/currencyRate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.currencyRate.search
      },
      set(newValue) {
        this.$store.commit('exchangeRate/currencyRate/SET_SEARCH', newValue)
        this.$store.commit('exchangeRate/currencyRate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('exchangeRate.date'),
          key: 'effective_date',
          fixed: 'left',
          width: 200
        },
        {
          title: this.$t('exchangeRate.fromCurrency'),
          key: 'fromC'
        },
        {
          title: this.$t('exchangeRate.toCurrency'),
          key: 'toC'
        },
        {
          title: this.$t('exchangeRate.fxRate'),
          key: 'fx_rate'
        },
        {
          title: this.$t('exchangeRate.fxRateRatio'),
          key: 'fx_rate_ratio'
        },
        {
          title: this.$t('exchangeRate.remarks'),
          key: 'remarks'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currencyRate/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('exchangeRate/currencyRate/SET_EDIT_DATA', {})
      this.showForm = false
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('exchangeRate/currencyRate/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
